import HttpRequest from "./HttpRequest"

class AuditingService {

  baseUrl = '/ton/v1/auditing/assets'

  httpRequest = new HttpRequest()

  async saveAuditing(assetId, body) {
    return this.httpRequest.post(`${this.baseUrl}/${assetId}`, body
    )
  }
}

export {AuditingService}


// WEBPACK FOOTER //
// ./src/services/AuditingService.js